const EVENT_BASE = 'kittoi:';

export const EVENT_READY = `${EVENT_BASE}ready`;

/**
 * カートの更新
 */
export const EVENT_GLOBAL_UPDATE_CART = `${EVENT_BASE}global:updateCart`;

/**
 * カートに追加ボタンのクリック
 */
export const EVENT_CLICK_ADD_CART_BUTTON = `${EVENT_BASE}click:addCartButton`;

/**
 * variantの変更
 */
export const EVENT_CHANGE_VARIANT = `${EVENT_BASE}change:variant`;

/**
 * 数量の変更
 */
export const EVENT_CHANGE_QUANTITY = `${EVENT_BASE}change:quantity`;

/**
 * ビューの更新
 */
export const EVENT_UPDATE_VIEW = `${EVENT_BASE}updateView`;

/**
 * ビューの更新イベント
 */
export const EVENT_UPDATE_VIEW_EVENTS = ['DOMContentLoaded', EVENT_UPDATE_VIEW];

/**
 * ヒーローの次の画像へのイベント
 */
export const EVENT_HERO_NEXT = `${EVENT_BASE}hero:next`;

/**
 * ヒーローのドットの表示
 */
export const EVENT_HERO_DOT_SHOW_START = `${EVENT_BASE}hero:dot:show-start`;
export const EVENT_HERO_DOT_SHOW = `${EVENT_BASE}hero:dot:show`;

/**
 * グローバルナビゲーションのトグル
 */
export const EVENT_GLOBAL_NAV_TOGGLE = `${EVENT_BASE}global-nav:toggle`;

/**
 * スクロールロックのイベント
 */
export const EVENT_SCROLL_LOCK_ON_DISABLE_START = `${EVENT_BASE}scroll-lock:onDisableStart`;
export const EVENT_SCROLL_LOCK_ON_DISABLE = `${EVENT_BASE}scroll-lock:onDisable`;
export const EVENT_SCROLL_LOCK_ON_ENABLE_START = `${EVENT_BASE}scroll-lock:onEnableStart`;
export const EVENT_SCROLL_LOCK_ON_ENABLE = `${EVENT_BASE}scroll-lock:onEnable`;
